import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, Output } from '@angular/core';
import { Subscription } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { without } from 'lodash';
import { AutoUnsubscribe, DIALOG_DEFAULT_CONFIG, DialogSize, IconNames, ValidationService } from '../../common';
import { AssignableCompartmentList, Compartments } from './models/compartments-selection.model';
import { CompartmentsSelectionDialogComponent } from './compartments-dialog/compartments-selection-dialog.component';
import { HubSelectionItem } from '../hubs-selection';

@Component({
    selector: 'container-compartments-selection',
    templateUrl: './compartments-selection.component.html',
    styleUrls: ['./compartments-selection.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
@AutoUnsubscribe
export class CompartmentsSelectionComponent {
  @Input() isDataEditable: boolean;
  @Input() title: string;
  @Input() description: string;

  @Input() set hubs(data: HubSelectionItem[]) {
    if (data) {
      this.hubIdList = [];
      data.forEach((item: HubSelectionItem) => {
        this.hubIdList.push(item.id);
      });
    }
  }

  @Input() set compartments(data: AssignableCompartmentList[]) {
    if (data) {
      this.compartmentList = data;
    }
  }

  @Output() listChange = new EventEmitter<AssignableCompartmentList[]>();

  compartmentList: AssignableCompartmentList[];
  subscriptions: Subscription[] = [];
  hubIdList: number[];
  iconNames = IconNames;

  constructor(public validationService: ValidationService, private dialog: MatDialog, private cd: ChangeDetectorRef) {}

  removeCompartment(compartmentListIndex: number, compartment: Compartments): void {
    if (this.compartmentList[compartmentListIndex].compartments.length > 1) {
      const selected: AssignableCompartmentList[] = this.compartmentList.reduce(
        (newArr: AssignableCompartmentList[], item: AssignableCompartmentList) => {
          const selectedCompartment: Compartments[] = item.compartments?.filter(
            (el: Compartments) => el !== compartment,
          );
          newArr.push({
            hubName: item.hubName,
            compartments: selectedCompartment.length ? selectedCompartment : [],
          });
          return newArr;
        },
        [],
      );
      this.compartmentList = selected;
    } else {
      this.compartmentList = [...without(this.compartmentList, this.compartmentList[compartmentListIndex])];
    }
    this.listChange.emit(this.compartmentList);
    this.cd.markForCheck();
  }

  manageCompartments(): void {
    this.dialog
      .open(CompartmentsSelectionDialogComponent, {
        data: { compartmentList: this.compartmentList, hubIdList: this.hubIdList },
        ...DIALOG_DEFAULT_CONFIG,
        width: DialogSize.LG,
      })
      .afterClosed()
      .subscribe((event: AssignableCompartmentList[]) => {
        if (event) {
          this.compartmentList = event;
          this.listChange.emit(this.compartmentList);
          this.cd.markForCheck();
        }
      });
  }
}
